import { TinyEmitter } from 'tiny-emitter';

export { default } from './DocumentShow.vue';

export const EventBus = new TinyEmitter();

export const DOCUMENT_EVENTS = {
    CREATE_QUESTION: 'ask-question',
    DELETE_QUESTION: 'delete-question',
};
